var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "handel-header" },
        [
          _c(
            "el-popover",
            {
              staticStyle: { padding: "0 !important" },
              attrs: { placement: "left-end", width: "700", trigger: "click" },
              model: {
                value: _vm.showPopover,
                callback: function ($$v) {
                  _vm.showPopover = $$v
                },
                expression: "showPopover",
              },
            },
            [
              _vm.showSelectView
                ? _c("crm-relative", {
                    ref: "crmrelative",
                    attrs: {
                      radio: false,
                      show: _vm.showPopover,
                      "selected-data": _vm.selectedData,
                      "crm-type": "product",
                    },
                    on: {
                      close: function ($event) {
                        _vm.showPopover = false
                      },
                      changeCheckout: _vm.selectInfos,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { slot: "reference", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showSelectView = true
                    },
                  },
                  slot: "reference",
                },
                [_vm._v("添加产品")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { staticStyle: { width: "100%" }, attrs: { data: _vm.productList } },
        [
          _c("el-table-column", {
            attrs: {
              prop: "name",
              "show-overflow-tooltip": "",
              label: "产品名称",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "category_id_info",
              "show-overflow-tooltip": "",
              label: "产品类别",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "unit", "show-overflow-tooltip": "", label: "单位" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "price",
              "show-overflow-tooltip": "",
              label: "标准价格",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "售价" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      directives: [
                        { name: "wk-number", rawName: "v-wk-number" },
                      ],
                      attrs: { placeholder: "请输入", type: "number" },
                      on: {
                        input: function ($event) {
                          return _vm.salesPriceChange(scope)
                        },
                      },
                      model: {
                        value: scope.row.sales_price,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "sales_price", $$v)
                        },
                        expression: "scope.row.sales_price",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "数量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      directives: [
                        { name: "wk-number", rawName: "v-wk-number" },
                      ],
                      attrs: { type: "number", placeholder: "请输入" },
                      on: {
                        input: function ($event) {
                          return _vm.numChange(scope)
                        },
                      },
                      model: {
                        value: scope.row.num,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "num", $$v)
                        },
                        expression: "scope.row.num",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "折扣（%）" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      directives: [
                        { name: "wk-number", rawName: "v-wk-number" },
                      ],
                      attrs: { placeholder: "请输入", type: "number" },
                      on: {
                        input: function ($event) {
                          return _vm.discountChange(scope)
                        },
                      },
                      model: {
                        value: scope.row.discount,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "discount", $$v)
                        },
                        expression: "scope.row.discount",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "subtotal", label: "合计" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.removeItem(scope.$index)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "flexbox",
        { staticClass: "handle-footer" },
        [
          _c("div", { staticClass: "discount-title" }, [
            _vm._v("整单折扣（%）："),
          ]),
          _vm._v(" "),
          _c("el-input", {
            directives: [{ name: "wk-number", rawName: "v-wk-number" }],
            staticStyle: { width: "80px" },
            attrs: { placeholder: "请输入", type: "number" },
            on: { input: _vm.rateChange },
            model: {
              value: _vm.discount_rate,
              callback: function ($$v) {
                _vm.discount_rate = $$v
              },
              expression: "discount_rate",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "total-info" },
            [
              _vm._v("已选中产品：\n      "),
              _c("span", { staticClass: "info-yellow" }, [
                _vm._v(_vm._s(_vm.productList.length)),
              ]),
              _vm._v(" 种  总金额：\n      "),
              _c("el-input", {
                directives: [{ name: "wk-number", rawName: "v-wk-number" }],
                staticStyle: { width: "120px" },
                attrs: { placeholder: "请输入", type: "number" },
                on: {
                  input: _vm.totalPriceChange,
                  blur: function ($event) {
                    _vm.total_price || (_vm.total_price = 0)
                  },
                },
                model: {
                  value: _vm.total_price,
                  callback: function ($$v) {
                    _vm.total_price = $$v
                  },
                  expression: "total_price",
                },
              }),
              _vm._v(" 元\n    "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }